export function R$(value?: string | number) {
  if (Number(value) === 0) return 'R$ 0,00';
  if (!value) return;
  return `R$ ${Number(value).toFixed(2).replace('.', ',')}`;
}
